import React from "react";
import { panelRoutesConfig } from "./panel/panelRoutesConfig";
import { errorRoutesConfig } from "./error/errorRoutesConfig";
import { authRoutesConfig } from "./auth/authRoutesConfig";

interface IRoute {
  auth: string[];
  path: string;
  component:
    | React.LazyExoticComponent<(props: any) => JSX.Element>
    | React.LazyExoticComponent<React.MemoExoticComponent<() => JSX.Element>>;
  title?: string;
  description?: string;
  layout?: React.LazyExoticComponent<(props: any) => JSX.Element>;
}

interface IRoutesConfig {
  auth: string[];
  path: string;
  layout: React.LazyExoticComponent<(props: any) => JSX.Element>;
  routes: IRoute[];
}

type IGlobalConfig = IRoute[];

const appRoutesConfig: IRoutesConfig[] = [panelRoutesConfig];
const appGlobalRoutes: IGlobalConfig = [
  ...errorRoutesConfig,
  ...authRoutesConfig,
];

export { appRoutesConfig, appGlobalRoutes };
export type { IRoutesConfig, IGlobalConfig };
